import { debounce } from 'lodash-es'
import { useDefaultModal } from '../defaultModal'
import Tip from './tip.vue'

export const useConsumeTip = debounce(() => {
  const { $t } = useNuxtApp()
  const cancel = () => modal.destroy()
  const modal = useDefaultModal({
    closable: true,
    maskClosable: true,
    header: true,
    title: $t('na-xie-cao-zuo-hui-xiao-hao-yan-bi'),
    footer: false,
    width: 952,
    content: <Tip cancel={cancel} />,
  })
}, 200)
